import React, { useCallback, useMemo } from 'react';
import classes from './Emotion.module.scss'
import { useTranslation } from 'react-i18next';
import { Button, Col, Row } from 'react-onsenui';

const Emotion = ({emotions, setEmotions}: Props) =>{
    const {t} = useTranslation()

    const emotionsList = useMemo(()=>({
        "pleasant":["gratitude", "joy", "satisfaction", "peace", "love", "pride"],
        "unpleasant":["anger", "sadness", "shame", "fear", "jealousy", "irritation", "anxiety" ]
    }), [])

    const toggleEmotion = useCallback((e:string)=>{
        let newEmotions:string[] = [];
        if(emotions.includes(e)){
            newEmotions = emotions.filter(ee=>ee!==e);
        }else{
            newEmotions = [...emotions]
            newEmotions.push(e);
        }
        console.log(emotions, e, newEmotions)
        setEmotions(newEmotions);
    }, [emotions, setEmotions]);

    return(
        <div className={classes.commentContainer}>
            <h3>{t('emotions.pleasant')}</h3>
            <Row>
                {emotionsList.pleasant.map(e=>{
                    const modifier = emotions.includes(e) ? 'material': 'outline';
                    return(
                        <Col className={classes.emotion}>
                            <Button modifier={modifier} onClick={()=>toggleEmotion(e)}>{t('emotions.'+e)}</Button>
                        </Col>
                )})}
            </Row>

            <h3>{t('emotions.unpleasant')}</h3>
            <Row>
                {emotionsList.unpleasant.map(e=>{
                    const modifier = emotions.includes(e) ? 'material': 'outline';
                    return(
                        <Col className={classes.emotion}>
                            <Button modifier={modifier} onClick={()=>toggleEmotion(e)}>{t('emotions.'+e)}</Button>
                        </Col>
                )})}
            </Row>
        </div>
    )
}

interface Props{
    emotions: string[],
    setEmotions: Function
}

export default Emotion;